/**
 * Wrapper for dataTestid.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- FIXME https://tinyurl.com/eslint-fixme
export const injDataTest = (name: string | string[]) => ({
  'data-testid': Array.isArray(name) ? name.join('-') : name,
  dataTest: Array.isArray(name) ? name.join('-') : name,
});
